module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_0.ed5923a3.png";